var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53033 5.80474C6.23744 6.06509 5.76256 6.06509 5.46967 5.80474L0.219671 1.13807C-0.0732226 0.877722 -0.0732226 0.455612 0.219671 0.195263C0.512563 -0.0650873 0.987438 -0.0650868 1.28033 0.195262L6 4.39052L10.7197 0.195261C11.0126 -0.0650887 11.4874 -0.0650882 11.7803 0.195261C12.0732 0.455611 12.0732 0.87772 11.7803 1.13807L6.53033 5.80474Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.0a57555705e488deb5848318a26b5816.svg";
export { ForwardRef as ReactComponent };